let api = {
  //印章柜相关

  // 印章柜查询摄像头列表[get](cabinetsId)
  cabinets_devicecabinets_cameraList: "/cabinets/devicecabinets/cameraList",
  // 印章柜新增摄像头[post](cabinetsId,cameraIp,cameraName)
  cabinets_devicecabinets_addCamera: "/cabinets/devicecabinets/addCamera",
  // 印章柜更新摄像头[post](cabinetsId, id, cameraIp, cameraName)
  cabinets_devicecabinets_updateCamera: "/cabinets/devicecabinets/updateCamera",
  // 印章柜删除摄像头[get](cameraIds)
  cabinets_devicecabinets_deleteCamera: "/cabinets/devicecabinets/deleteCamera",

  // 查询印章柜-摄像头(树)
  cabinets_devicecabinets_findCamera: "cabinets/devicecabinets/findCamera",
  // 摄像头预置点列表[get](cameraId)
  cabinets_devicecabinets_pointList: "/cabinets/devicecabinets/pointList",
  // 摄像头增加预置点[post](pointNum, pointName, cameraId)
  cabinets_devicecabinets_addPoint: "/cabinets/devicecabinets/addPoint",
  // 摄像头更新预置点[post](pointNum, pointName, cameraId)
  cabinets_devicecabinets_updatePoint: "/cabinets/devicecabinets/updatePoint",
  // 摄像头删除预置点[get](pointIds)
  cabinets_devicecabinets_deletePoint: "/cabinets/devicecabinets/deletePoint",

  cmy_cabinets_devicecabinets_findList: "/cabinets/devicecabinets/findList", //查询印章柜列表
  cmy_auth_user_getUsersByOrg: "/auth/user/getUsersByOrg", //查询印章柜管理人列表
  // cmy_auth_org_getOrganizational:'/auth/org/getOrganizational',//查询组织机构树
  cmy_cabinets_devicecabinets_add: "/cabinets/devicecabinets/add", //添加印章柜列表数据
  cmy_cabinets_devicecabinets_delete: "/cabinets/devicecabinets/delete", //删除印章柜列表数据
  cmy_cabinets_devicecabinets_update: "/cabinets/devicecabinets/update", //编辑印章柜列表数据
  cmy_entrance_deviceEntrance_findPassword:
    "/entrance/deviceEntrance/findPassword", //印章柜查看密码
  cmy_auth_department_getLevelsByOrgForAddAndUpdateEmployee:
    "/auth/department/getLevelsByOrgForAddAndUpdateEmployee", //查询组织机构树
  cmy_cabinets_devicecabinetsface_findList:
    "/cabinets/devicecabinetsface/findList", //查寻人员认证列表
  cmy_cabinets_devicecabinetsface_delete: "/cabinets/devicecabinetsface/delete", //删除人员列表数据
  cmy_cabinets_devicecabinets_treeNode: "/cabinets/devicecabinets/treeNode", //查询印章柜与抽屉数
  cmy_cabinets_devicecabinets_deviceTree: "/cabinets/devicecabinets/deviceTree", //印章组织树
  cmy_cabinets_devicecabinets_findDeviceList:
    "/cabinets/devicecabinets/findDeviceList", //查询印章柜设备列表
  cmy_cabinets_devicecabinets_addDevice: "/cabinets/devicecabinets/addDevice", //新增印章入柜
  cmy_cabinets_devicecabinets_writeTag: "/cabinets/devicecabinets/writeTag", //写入标签
  cmy_cabinets_devicecabinets_deleteDevice:
    "/cabinets/devicecabinets/deleteDevice", //印章入柜删除
  cmy_cabinets_devicecabinets_checkTag: "/cabinets/devicecabinets/checkTag", //核对标签
  cmy_cabinets_devicecabinets_updateDevice:
    "/cabinets/devicecabinets/updateDevice", //更新设备
  cmy_cabinets_devicecabinets_check: "/cabinets/devicecabinets/check", //盘点
  cmy_cabinets_deviceCabinetsUseRecords_findList:
    "/cabinets/deviceCabinetsUseRecords/findList", //存取记录表
  cmy_cabinets_deviceCabinetsCheckRecords_findList:
    "/cabinets/deviceCabinetsCheckRecords/findList", //盘存记录
  cmy_cabinets_devicecabinets_cabinetsStatistical:
    "/cabinets/devicecabinets/cabinetsStatistical", //印章柜统计
  cmy_cabinets_devicecabinets_drawerStatistical:
    "/cabinets/devicecabinets/drawerStatistical", //抽屉统计
  cmy_cabinets_devicecabinets_ipDetection:
    "/cabinets/devicecabinets/ipDetection", //ip链接检测
  cmy_applet_orgList: "/applet/orgList", //获取租户列表
  cmy_applet_addOrg: "/applet/addOrg", //添加租户
  cmy_applet_updateOrg: "/applet/updateOrg", //更新租户信息
  cmy_applet_syncData: "/applet/syncData", //同步数据
  cmy_entrance_deviceEntrance_deleteByIds:
    "/entrance/deviceEntrance/deleteByIds", //门禁管理删除
  cmy_entrance_deviceEntrance_findList: "/entrance/deviceEntrance/findList", //门禁管理查询
  cmy_entrance_deviceEntrance_updatePassword:
    "/entrance/deviceEntrance/updatePassword", //门禁修改密码
  cmy_entrance_deviceEntrance_save: "/entrance/deviceEntrance/save", //门禁管理新增
  cmy_entrance_deviceEntranceFace_deleteByIds:
    "/entrance/deviceEntranceFace/deleteByIds", //删除人脸
  cmy_entrance_deviceEntranceFace_remove: "/entrance/deviceEntranceFace/remove", //清空人脸
  cmy_entrance_deviceEntrance_update: "/entrance/deviceEntrance/update", //门禁管理更新
  cmy_entrance_deviceEntranceFace_findList:
    "/entrance/deviceEntranceFace/findList", //门禁人脸管理
  cmy_entrance_deviceEntranceRecords_findList:
    "/entrance/deviceEntranceRecords/findList", //门禁记录查询
  cmy_entrance_deviceEntranceFace_uploadFace:
    "/entrance/deviceEntranceFace/uploadFace", //门禁人脸上传
  cmy_entrance_deviceEntranceFace_findFaceList:
    "/entrance/deviceEntranceFace/findFaceList", //人脸库查询
  cmy_entrance_deviceEntranceFace_faceRelation:
    "/entrance/deviceEntranceFace/faceRelation", //人脸库关联
  cmy_entrance_deviceEntranceFace_relationList:
    "/entrance/deviceEntranceFace/relationList", //已关联列表
  cmy_device_scanner_findScannerAfterUsingCompareInfo:
    "/device/scanner/findScannerAfterUsingCompareInfo", //扫描对比详情
  cmy_device_scanner_findList: "/device/scanner/findList", //扫描记录列表
  cmy_application_application_pushAndUnlock:
    "/application/application/pushAndUnlock", //解锁用印
  // 系统消息,标记已读 (noticeIds)
  cmy_auth_notice_tagRead: "/auth/notice/tagRead",
  //关键字管理
  cmy_param_findList: "/param/findList", //查询列表
  cmy_param_add: "/param/add", //新增
  cmy_param_update: "/param/update", //更新
  cmy_param_deleteByIds: "/param/deleteByIds", //删除
  cmy_entrance_deviceEntranceFace_updateById:
    "/entrance/deviceEntranceFace/updateById", //门禁管理开关
  cmy_device_signet_unlock: "/device/signet/unlock",
  cmy_auth_department_findTenantTree: "/auth/department/findTenantTree", //筛选组织机构
  cmy_auth_department_findOwnerDepts: "/auth/department/findOwnerDepts", //获取组织机构
  cmy_application_application_cancelApplication:
    "/application/application/cancelApplication", //关闭申请单
  cmy_application_application_retryOcr: "/application/application/retryOcr", //ocr重新识别

  cmy_sys_config_property_findEnabledConfigKeys:
    "/sys/config/property/findEnabledConfigKeys", //系统属性配置添加下拉框

  cmy_org_dict_findList: "/org/dict/findList", //租户字典查询字典
  cmy_org_dict_create: "/org/dict/create", //租户字典添加字典
  cmy_org_dict_delete: "/org/dict/delete/", //租户字典删除字典
  cmy_org_dict_update: "/org/dict/update", //租户字典修改字典
  cmy_org_dict_categories: "/org/dict/categories", //租户字典类别

  cmy_device_deviceType_create: "/device/deviceType/create", //添加印章类型
  cmy_device_deviceType_delete: "/device/deviceType/delete/", //删除印章类型
  cmy_device_deviceType_update: "/device/deviceType/update", //修改印章类型

  cmy_auth_orgEmail_batchUpdate: "/auth/orgEmail/batchUpdate", //批量更新邮件通知
  cmy_auth_orgEmail_findOwnerTemplate: "/auth/orgEmail/findOwnerTemplate", //邮件设置列表
  cmy_auth_orgEmail_singleUpdate: "/auth/orgEmail/singleUpdate", //更新邮件通知

  cmy_application_application_updateUnlockThreshold:
    "/application/application/updateUnlockThreshold", //申请详情阈值修改

  cmy_physical_seal_update_flowCategoryList:
    "/physical/seal/update/flowCategoryList", //变更记录 流程列表
  cmy_physical_seal_update_list: "/physical/seal/update/list", //变更记录 查询变更列表
  cmy_physical_seal_update_approvalStatusList:
    "/physical/seal/update/approvalStatusList", //变更记录 审批状态列表
  cmy_physical_seal_update_userList: "/physical/seal/update/userList", //获取成员列表
  cmy_physical_seal_update_deptTreeList: "/physical/seal/update/deptTreeList", //组织树列表
  cmy_physical_seal_update_updateApplicationInfo:
    "/physical/seal/update/updateApplicationInfo", //详情

  cmy_physical_seal_change_flowCategoryList:
    "/physical/seal/change/flowCategoryList", //换章记录 流程列表
  cmy_physical_seal_change_list: "/physical/seal/change/list", //换章记录 查询换章列表
  cmy_physical_seal_change_approvalStatusList:
    "/physical/seal/change/approvalStatusList", //换章记录 审批状态列表
  cmy_physical_seal_change_userList: "/physical/seal/change/userList", //获取成员列表
  cmy_physical_seal_change_deptTreeList: "/physical/seal/change/deptTreeList", //组织树列表
  cmy_physical_seal_change_changeApplicationInfo:
    "/physical/seal/change/changeApplicationInfo", //详情

  cmy_signet_transfer_record_flowCategoryList:
    "/signet/transfer/record/flowCategoryList", //移交记录 流程列表
  cmy_signet_transfer_record_list: "/signet/transfer/record/list", //移交记录 查询移交列表
  cmy_signet_transfer_record_approvalStatusList:
    "/signet/transfer/record/approvalStatusList", //移交记录 审批状态列表
  cmy_signet_transfer_record_userList: "/signet/transfer/record/userList", //获取成员列表
  cmy_signet_transfer_record_deptTreeList:
    "/signet/transfer/record/deptTreeList", //组织树列表
  cmy_signet_transfer_record_updateApplicationInfo:
    "/signet/transfer/record/updateApplicationInfo", //详情

  cmy_physical_seal_carved_flowCategoryList:
    "/physical/seal/carved/flowCategoryList", //刻章记录 流程列表
  cmy_physical_seal_carved_list: "/physical/seal/carved/list", //刻章记录 查询刻章列表
  cmy_application_flow_flowCategoryList: "/application/flow/flowCategoryList",//流程管理 流程类型
  cmy_physical_seal_carved_approvalStatusList:
    "/physical/seal/carved/approvalStatusList", //刻章记录 审批状态列表
  cmy_physical_seal_carved_userList: "/physical/seal/carved/userList", //获取成员列表
  cmy_physical_seal_carved_deptTreeList: "/physical/seal/carved/deptTreeList", //组织树列表
  cmy_physical_seal_carved_carvedApplicationInfo:
    "/physical/seal/carved/carvedApplicationInfo", //详情
  cmy_device_report_recordToExportExcel:"/device/report/recordToExportExcelV2",//使用记录导出

  cmy_ele_auth_getCorpAuthUrl:"/ele/auth/getCorpAuthUrl",//获取企业授权链接
  cmy_ele_auth_getMemberActiveUrl:"/ele/auth/getMemberActiveUrl",//获取个人授权链接
  cmy_ele_auth_getAuthListIdentify:"/ele/auth/getAuthListIdentify",//获取认证列表
  cmy_ele_auth_createMember:"/ele/auth/createMember",//提交认证人员
  cmy_ele_seal_getManageUrl:"/ele/seal/getManageUrl",//获取印章管理的页面链接
  cmy_ele_auth_getUserAuthDetail:"/ele/auth/getUserAuthDetail",//获取用户详情
  cmy_ele_auth_getCorpAuthDetail:"/ele/auth/getCorpAuthDetail",//获取企业详情
  cmy_ele_seal_createUrl:"/ele/seal/createUrl",//创建印章链接
  cmy_ele_seal_list:"/ele/seal/list",//电子印章列表
  cmy_ele_seal_detail:"/ele/seal/detail",//电子印章详情
  cmy_ele_seal_insertEleSealKeeper:"/ele/seal/insertEleSealKeeper",//保存印章详情
  cmy_ele_seal_queryEleSeal:"/ele/seal/queryEleSeal",//申请单可用电子印章
  cmy_seal_grantUrl:"/ele/seal/grantUrl",//获取授权链接
  cmy_ele_application_create:"/ele/application/create",//创建电子章申请单
  cmy_application_flow_ele_getByOwner:"/application/flow/ele/getByOwner",//获取审批流程表单
  cmy_ele_auth_getUserAuthUrl:"/ele/auth/getUserAuthUrl",//获取用户授权链接
  cmy_ele_seal_querySealGrantUser:"/ele/seal/querySealGrantUser",//获取签署人列表
  cmy_ele_application_getSignList:"/ele/application/getSignList",//签署任务列表
  cmy_signTask_getActorUrl:"/signTask/getActorUrl",//获取参会方签署任务链接
  cmy_signTask_cancel:"/signTask/cancel",//签署任务撤销
  cmy_ele_seal_setSealStatus:"/ele/seal/setSealStatus",//设置印章状态
  cmy_ele_seal_deleteSeal:"/ele/seal/deleteSeal",//删除印章

  cmy_sysFace_findList:"/sysFace/findList",//人脸库管理 查询列表
  cmy_sysFace_uploadFace:"/sysFace/uploadFace",//人脸库管理 文件上传
  cmy_sysFace_deleteByIds:"/sysFace/deleteByIds",//删除人脸
  cmy_sysFace_remove:"/sysFace/remove",//清空人脸
  cmy_device_signet_addFace:"/device/signet/addFace",//远程控制 录入人脸
  cmy_sysFace_findFaceList:"/sysFace/findFaceList",//人脸库查询
  cmy_sysFace_relationList:"/sysFace/relationList",//已关联列表
  cmy_sysFace_faceRelation:"/sysFace/faceRelation",//人脸库关联
  cmy_device_signet_getFaceUserBySignetId:"/device/signet/getFaceUserBySignetId",//人脸录入用户列表

  cmy_physical_seal_getPhysicalSeal:"/physical/seal/getPhysicalSeal",//用章申请 物理印章列表
  cmy_physical_seal_createApplication:"/physical/seal/createApplication",//物理印章 用章申请
  cmy_physical_seal_getPhysicalUseRecord:"/physical/seal/getPhysicalUseRecord",//物理章申请记录
  cmy_physical_seal_physicalSealApplicationDetail:"/physical/seal/physicalSealApplicationDetail",//申请单详情

  cmy_application_application_rePrint:"/application/application/rePrint",//申请详情打印指令发送
  cmy_application_application_rePrintH5:"/application/application/rePrintH5",//申请详情打印指令发送H5
  cmy_auth_user_getOrgAllUser:"/auth/user/getOrgAllUser",//获取管章人列表

  cmy_auth_user_saveUserGroup:"/auth/user/saveUserGroup",//新增用户组
  cmy_auth_user_userGroupList:"/auth/user/userGroupList",//用户组列表
  cmy_auth_user_delUserGroup:"/auth/user/delUserGroup",//删除用户组
  cmy_auth_user_editUserGroup:"/auth/user/editUserGroup",//编辑用户组
  cmy_auth_department_getDepUserTree:"/auth/department/getDepUserTree",//用户树列表
  cmy_printGroup_manage_user_groups:"/printGroup/manage/user/groups",//用户组列表

  cmy_printGroup_manage_add:"/printGroup/manage/add",//添加打印机
  cmy_printGroup_manage_del:"/printGroup/manage/del",//删除打印机
  cmy_printGroup_manage_update:"/printGroup/manage/update",//修改打印机
  cmy_printGroup_manage_list:"/printGroup/manage/list",//打印机列表

  cmy_application_application_getByMyApplicationH5:"/application/application/getByMyApplicationH5",//获取h5页面申请单详情
  cmy_auth_user_tkExchangeUserInfo:"/auth/user/tkExchangeUserInfo",//获取单点登录用户信息
  cmy_auth_user_ticketExtToken:"/auth/user/ticketExtToken",//获取token

  // ========== 讯飞 ==========
  // 扇形统计图
  cmy_auth_notice_sectorStatistics:"/auth/notice/sectorStatistics",
  // 折线统计图
  cmy_auth_notice_brokenLineStatistics:"/auth/notice/brokenLineStatistics",
  // 消息列表 {startTime,endTime,warnType,handlerStatus,warnUserName,deviceName,warnContent}
  cmy_auth_notice_getForewarningNotices:"/auth/notice/getForewarningNotices",
  // 批量处理 {noticeIds,remark}
  cmy_auth_notice_batchHandle:"/auth/notice/batchHandle",
  // 批量已读(noticeIds)
  cmy_auth_notice_batchRead:"/auth/notice/batchRead",
  // 设置低频预警阈值(deviceId,dayThresholdValue,weekThresholdValue,monthThresholdValue)
  threshold_updateThreshold: '/threshold/updateThreshold',
  // -----组织用印报表----
  // 柱状图
  department_statistics_histogram: '/department/statistics/histogram',
  // 部门统计用印列表(deviceName,departmentName,startTime,endTime,applicationUserName,sealUserName)
  department_statistics_departmentStatisticsList: '/department/statistics/departmentStatisticsList',
  // -----用印统计报表-----
  // 按年统计柱状图
  department_statistics_histogramByYear: '/department/statistics/histogramByYear',
  // 用印流程统计柱状图
  department_statistics_histogramFlowByYear: '/department/statistics/histogramFlowByYear',
  // 印章以及申请单使用情况列表(deviceName,deviceType,startTime,endTime,applicationUserName,sealUserName)
  department_statistics_deviceStatisticsList: '/department/statistics/deviceStatisticsList',
  // -----预警报表------
  // 预警统计柱状图(warnType, status)
  forewarning_statistics_forewarningStatisticsHistogram: '/forewarning/statistics/forewarningStatisticsHistogram',
  // 添加印油[get](signetId)
  device_signet_addOil: '/device/signet/addOil',


  // 查询快递柜抽屉占用情况(drawerId)
  cabinets_devicecabinets_useGrid: '/cabinets/devicecabinets/useGrid',
  // 从印章柜拿取物理印章(deviceId)
  cabinets_devicecabinets_receiveSeal: '/cabinets/devicecabinets/receiveSeal',
  // 查询抽屉列表(cabinetsId:印章柜id)
  cabinets_devicecabinetsdrawer_findList: '/cabinets/devicecabinetsdrawer/findList',
  // 设置抽屉行列(drawerId:抽屉id,rows,columns)
  cabinets_devicecabinetsdrawer_setRowsAndColumns: '/cabinets/devicecabinetsdrawer/setRowsAndColumns',
  cabinets_devicecabinets_revocationSeal: '/cabinets/devicecabinets/revocationSeal'
}
export default api



// WEBPACK FOOTER //
// ./src/api/cmy_api.js